require('scripts/setup');
require('scripts/core').start();